// extracted by mini-css-extract-plugin
export default {"products":"Yt-z","card":"Zt-z","oosMessaging":"_t-z"};